// /src/components/Analytics.js
'use client';

import Script from 'next/script';
import { useEffect } from 'react';

export default function Analytics() {
  // We use useEffect to ensure this code only runs in the browser
  useEffect(() => {
    // This function contains the logic from your DataDog script.
    const initDataDog = () => {
      if (window.DD_RUM) {
        window.DD_RUM.init({
          clientToken: process.env.NEXT_PUBLIC_DATA_DOG_CLIENT_TOKEN,
          applicationId: process.env.NEXT_PUBLIC_DATA_DOG_APP_ID,
          site: process.env.NEXT_PUBLIC_DATA_DOG_SITE,
          service: process.env.NEXT_PUBLIC_DATA_DOG_SERVICE,
          env: process.env.NEXT_PUBLIC_DATA_DOG_ENV,
          version: process.env.NEXT_PUBLIC_DATA_DOG_VERSION,
          sessionSampleRate: 45,
          sessionReplaySampleRate: 20,
          trackUserInteractions: true,
          trackResources: true,
          trackLongTasks: true,
          defaultPrivacyLevel: 'mask-user-input',
        });
        window.DD_RUM.startSessionReplayRecording();
      }
    };

    // Check if we are in the production environment before loading scripts
    if (process.env.NODE_ENV === 'production') {
      // Create a script element for DataDog
      const ddScript = document.createElement('script');
      ddScript.src = 'https://www.datadoghq-browser-agent.com/us1/v5/datadog-rum.js';
      ddScript.type = 'text/javascript';
      ddScript.crossOrigin = 'anonymous';
      ddScript.onload = initDataDog; // Initialize after the script loads
      document.head.appendChild(ddScript);

      // Create a script element for OneTrust
      const otScript = document.createElement('script');
      otScript.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
      otScript.setAttribute('data-domain-script', 'a94ca794-e01f-45f7-a5c0-0cae5107e46e');
      document.head.appendChild(otScript);
    }
  }, []);

  // For the Adobe scripts, we can use the next/script component directly.
  // These will only be rendered in a production environment.
  return (
    <>
      {process.env.NODE_ENV === 'production' && (
        <>
          <Script id="adobe-anti-flicker">
            {`(function(g,b,d,f){(function(a,c,d){if(a){var e=b.createElement("style");e.id=c;e.innerHTML=d;a.appendChild(e)}})(b.getElementsByTagName("head")[0],"at-body-style",d);setTimeout(function(){var a=b.getElementsByTagName("head")[0];if(a){var c=b.getElementById("at-body-style");c&&a.removeChild(c)}},f)})(window,document,"body {opacity: 0 !important}",750);`}
          </Script>
          <Script id="adobe-launch" src="https://assets.adobedtm.com/98980a4572ae/f15a11e17c97/launch-fa4d8a34177c.min.js" strategy="afterInteractive" />
        </>
      )}
    </>
  );
}